import React, { useState } from 'react';
import { Button, Modal, Radio, Space, Form, message } from 'antd';
import { generateGroupSingleMatch, generateNewMatchDays } from 'api/events';

export const JornadasModal = ({
  isVisible,
  setIsModalVisible,
  tournamentId,
  groupId,
  onLoadRounds,
}) => {
  const [isJornada, setIsJornada] = useState(true);

  const handleOnSubmit = async ({ create_type, match_conf }) => {
    if (create_type === 'group') {
      try {
        message.loading('Creando Jornada...', 1);
        await generateGroupSingleMatch(tournamentId, groupId);
        message.success('!Jornada creada con éxito!');
        onLoadRounds();
        setIsModalVisible(false);
      } catch (error) {
        message.error('!Ha ocurrido un error!');
        setIsModalVisible(false);
      }
    } else {
      try {
        message.loading('Creando Etapa...', 1);
        await generateNewMatchDays(tournamentId, groupId, match_conf);
        message.success('!Etapa creada con éxito!');
        onLoadRounds();
        setIsModalVisible(false);
      } catch (error) {
        message.error('!Ha ocurrido un error!');
        setIsModalVisible(false);
      }
    }
  };

  const handleOnRadioChange = e => {
    e.target.value === 'group' ? setIsJornada(true) : setIsJornada(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="Administrar"
      onOk={() => setIsModalVisible(false)}
      onCancel={() => setIsModalVisible(false)}
      footer={[
        <Button onClick={() => setIsModalVisible(false)} key="back">
          Cancelar
        </Button>,
        <Button form={'jornadasForm'} htmlType="submit" key="submit" type="primary">
          Crear
        </Button>,
      ]}
    >
      <Form layout="vertical" id={'jornadasForm'} onFinish={values => handleOnSubmit(values)}>
        <Form.Item
          label="Crear nueva:"
          name="create_type"
          initialValue="group"
          rules={[
            {
              required: true,
              message: 'Ingrese la fecha de inicio!',
            },
          ]}
        >
          <Radio.Group onChange={e => handleOnRadioChange(e)}>
            <Space direction="vertical">
              <Radio value="group">Jornada</Radio>
              <Radio value="match">Etapa</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Configurar nueva etapa:"
          name="match_conf"
          hidden={isJornada}
          rules={[
            {
              required: !isJornada,
              message: 'Ingrese la fecha de inicio!',
            },
          ]}
        >
          <Radio.Group disabled={isJornada}>
            <Space direction="vertical">
              <Radio value={false}>Ida</Radio>
              <Radio value={true}>Ida / Vuelta</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};
